// src/components/desk/BuildingFacts.jsx — year built · lift · parking · heating.
//
// ⚠️ ITS OWN FILE ON PURPOSE, like ContactOptOutPanel. It is used by BOTH the add-listing editor
// (ManualPropertyModal) and the valuation tab (CardAnalysis) — owner 2026-09-16: "questions filled
// like it would be adding new listing", so a fact has ONE control wherever it is asked. Living
// inside ManualPropertyModal it dragged leaflet into every importer, so neither the valuation tab
// nor a render check could use it without the whole 3,500-line editor.
import { t } from '../../lib/i18n.js'
import { pill } from './primitives.jsx'
import { HEATING_CODES, YEAR_BUILT_MIN, yearBuiltMax } from '../../lib/buildingFacts.js'
export { HEATING_CODES, changedChipStates } from '../../lib/buildingFacts.js'

// The selected-pill style, the same token MatchSuggestions calls TIER_STYLE.must. Copied rather
// than imported: importing it would pull that 3,300-line module (gallery, listings tab) into a
// four-control component whose whole point is to be light enough to reuse and render-check.
const SELECTED = 'bg-green-600/20 border-green-600 text-green-500'
const SELECTED_NO = 'bg-rose-600/15 border-rose-500 text-rose-500'

// ── Building facts the listing form asks (owner 2026-09-16) ─────────────────────────────────────
export function BuildingFacts({ facts, setFacts, featAns, setFeatAns, highlight = null }) {
  const hl = k => (highlight && highlight.has(k) ? 'ring-1 ring-amber-400/70 rounded-lg p-1 -m-1' : '')
  const Tri = ({ k, label }) => (
    <div data-bf-row={k} data-bf-ask={highlight && highlight.has(k) ? 'yes' : 'no'} className={`flex items-center gap-1.5 flex-wrap ${hl(k)}`}>
      <span className="text-xs text-muted-foreground w-20 shrink-0">{label}</span>
      {[['true', t('desk_facts_yes')], ['false', t('desk_facts_no')]].map(([v, l]) => (
        <button key={v} type="button" data-bf={`${k}:${v}`} aria-pressed={featAns[k] === v}
          onClick={() => setFeatAns(a => ({ ...a, [k]: a[k] === v ? '' : v }))}
          className={pill('none', { door: true, extra: featAns[k] === v ? (v === 'true' ? SELECTED : SELECTED_NO) : 'border-border text-muted-foreground hover:bg-muted' })}>
          {l}
        </button>
      ))}
      {/* "Not stated" is a visible answer-state, not the absence of a button (redesign stage 1). It is
          never data-bf, so it can never be read as an answer. */}
      <button type="button" data-bf-clear={k} aria-pressed={featAns[k] === ''}
        onClick={() => setFeatAns(a => ({ ...a, [k]: '' }))}
        className={pill('none', { door: true, extra: `border-dashed ${featAns[k] === '' ? 'border-muted-foreground/60 text-foreground' : 'border-border text-muted-foreground hover:bg-muted'}` })}>
        {t('desk_tristate_not_stated')}
      </button>
    </div>
  )
  return (
    <div className="mt-3 space-y-2">
      <label data-bf-row="year_built" data-bf-ask={highlight && highlight.has('year_built') ? 'yes' : 'no'} className={`flex items-center gap-2 ${hl('year_built')}`}>
        <span className="text-xs text-muted-foreground w-20 shrink-0">{t('desk_facts_year_built')}</span>
        <input type="number" inputMode="numeric" min={YEAR_BUILT_MIN} max={yearBuiltMax()} step="1" data-bf="year_built"
          value={facts.year_built} onChange={e => setFacts(f => ({ ...f, year_built: e.target.value }))}
          className="w-24 rounded-lg border border-border bg-background px-2 py-0.5 text-sm" />
      </label>
      <Tri k="elevator" label={t('desk_facts_elevator')} />
      <Tri k="parking" label={t('desk_facts_parking')} />
      <div data-bf-row="heat" data-bf-ask={highlight && highlight.has('heat') ? 'yes' : 'no'} className={hl('heat')}>
        <p className="text-xs text-muted-foreground mb-1">{t('desk_facts_heating')}</p>
        <div className="flex flex-wrap gap-1.5">
          {HEATING_CODES.map(code => (
            <button key={code} type="button" data-bf={`heat:${code}`} aria-pressed={featAns.heat.includes(code)}
              onClick={() => setFeatAns(a => ({ ...a, heat: a.heat.includes(code) ? a.heat.filter(c => c !== code) : [...a.heat, code] }))}
              className={pill('none', { door: true, extra: featAns.heat.includes(code) ? SELECTED : 'border-border text-muted-foreground hover:bg-muted' })}>
              {t(`desk_${code}`)}
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}

